import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { HowItWorks } from '../components/HowItWorks';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white overflow-x-hidden" data-id="element-126">
      <Header data-id="element-127" />
      <Hero data-id="element-128" />
      <ProblemSection data-id="element-129" />
      <SolutionSection data-id="element-130" />
      <HowItWorks data-id="element-131" />
      <Services data-id="element-132" />
      <WhyUs data-id="element-133" />
      <CTASection data-id="element-134" />
      <Footer data-id="element-135" />
    </main>;
}